"use strict";

module.exports = class snap {
	constructor(config) {
		this.config = config;
		this.snap = '[data-snap-index]';
		this.snapControls = '[data-snap-el="controls"]';
		this.snapButton = '[data-snap-dir]';
		this.activeClass = 'is-active';
		this.endItemClass = 'is-end';
		this.startItemClass = 'is-start';
	}
	/**
	 * initialize
	 * @description Scroll to section au click
	 * @param arr représente un array (querySelectorAll) d'éléments html
	 */
	carousel(selector) {
		let self = this,
				elementSnap = document.querySelector(`${selector} ${this.snap}`);

		/// Event click arrow
		if (helpers.elementExist(`${selector} ${this.snapControls}`)) {
			if(parseInt(elementSnap.dataset.snapIndex) === 0) {
				document.querySelector(`${selector}`).classList.add(self.startItemClass)
			}
	
			document.querySelectorAll(`${selector} ${this.snapControls}`).forEach(el => {
				el.addEventListener('click', function (btn) {
					let scrollBy = parseInt(btn.target.dataset.step) > 1 ? parseInt(btn.target.dataset.step) : 1;

					let width = elementSnap.children[elementSnap.dataset.snapIndex].clientWidth,
						dir = btn.target.dataset.snapDir === ">" ? scrollBy * width : -scrollBy * width;
					elementSnap.scrollBy({
						top: 0,
						left: dir,
						behavior: 'smooth'
					});
					elementSnap.dataset.snapIndex = parseInt(elementSnap.dataset.snapIndex) + dir / width;

					for (const item of elementSnap.children) {
						item.classList.remove(self.activeClass);
					}
					
					/// Gestion des classes : élément actif, début ou fin du carousel
					if (parseInt(elementSnap.dataset.snapIndex) + scrollBy >= parseInt(elementSnap.dataset.boxesCount)) {
						document.querySelector(`${selector}`).classList.add(self.endItemClass);
						document.querySelector(`${selector}`).classList.remove(self.startItemClass);
					} else if(parseInt(elementSnap.dataset.snapIndex) === 0) {
						document.querySelector(`${selector}`).classList.add(self.startItemClass);						
						document.querySelector(`${selector}`).classList.remove(self.endItemClass);
					} else {
						elementSnap.children[elementSnap.dataset.snapIndex].classList.add(self.activeClass);
						document.querySelector(`${selector}`).classList.remove(self.startItemClass);
						document.querySelector(`${selector}`).classList.remove(self.endItemClass);
					}
				})
			})
		}
	}
}